import React, { useEffect, useState } from "react";
import { Doughnut, Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";
import {
  colorBlack,
  colorWhite,
  primaryColor,
} from "../../../../../utility/constants/colorManager";
import { TbRefresh } from "react-icons/tb";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import CustomModal from "../../../../components/main_comps/custom_modal";
import FilterModal from "../../dashboard/FilterModal";
import { useDispatch, useSelector } from "react-redux";
import {
  clearGlobalFilterReducer,
  showHideFilterModalReducer,
} from "../../../../../data/redux/slice/globalFiltersSlice";
import MainComponent from "../../../../components/ui_comps/MainComponent";
import TopHeaderComponent from "../../../../components/ui_comps/TopHeaderComponent";
import { ApiRequestGet } from "../../../../../data/network/services/ApiRequestGet";
import {
  CLIENT,
  STATUS_CODE_200,
  SUCCESS,
  VAN_TRANSACTION_COUNT,
  VAN_TRANSACTION_RATE,
  VAN_TRANSACTION_VOLUME,
} from "../../../../../utility/constants/valueConstants";
import { clientSecret } from "../../../../../data/redux/slice/listingDataSlice";
import moment from "moment";
import { useLocation } from "react-router";
import secureStorage from "../../../../../services/secureStorage";
import {
  SS_ROLE,
  SS_USER_HASH_ID,
} from "../../../../../utility/constants/secureStorageManager";
import { clearDashboardFilter } from "../../../../../data/redux/slice/countsSlice";
import { fetchClientSecretId } from "../../../../../services/fetchListingData";
import CustomSelect from "../../../../components/main_comps/custom_select";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  Tooltip,
  Legend
);

const VanDashbaordIndex = () => {
  const filters = useSelector((state) => state.globalFiltersSlice);
  const clientList = useSelector((state) => state.dropDownListSlice.clientList);
  const dispatch = useDispatch();
  const role = secureStorage.getItem(SS_ROLE);
  const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
  const location = useLocation();
  const [dashboardValues, setDashboardValues] = useState({});
  const [userRole, setUserRole] = useState("");
  const [Year, setYear] = useState(new Date().getFullYear());
  const [filterDate, setFilterDate] = useState(new Date());
  const [onClickFilter, setOnClickFilter] = useState(false);
  const [clientDetails, setClientDetials] = useState({});
  const clientSecret = useSelector((state) => state.listingSlice.clientDetails);
  const aclData = useSelector((state) => state.aclSlice.aclList);
  const [currentSvcProvider, setCurrentSvcProvider] = useState();
  const [optsSvcArr, setOptsSvcArr] = useState([]);
  const serviceProviders = [
    {
      label: "Equitas Van",
      value: "van",
    },
    {
      label: "Van Upi",
      value: "van-upi",
    },
  ];
  const [transactionVolume, setTransactionVolume] = useState({
    labels: [
      "JAN",
      "FEB",
      "MAR",
      "APR",
      "MAY",
      "JUN",
      "JUL",
      "AUG",
      "SEP",
      "OCT",
      "NOV",
      "DEC",
    ],

    datasets: [
      {
        label: "",
        data: [],
        borderColor: ["#38369C"],
        tension: 0.4,
        pointStyle: "false",
        pointRadius: 0,
        borderWidth: 1,
      },
    ],
  });
  const [transactionCount, setTransactionCount] = useState({
    labels: [
      "JAN",
      "FEB",
      "MAR",
      "APR",
      "MAY",
      "JUN",
      "JUL",
      "AUG",
      "SEP",
      "OCT",
      "NOV",
      "DEC",
    ],

    datasets: [
      {
        label: "",
        data: [],
        borderColor: ["#38369C"],
        tension: 0.4,
        pointStyle: "false",
        pointRadius: 0,
        borderWidth: 1,
      },
    ],
  });

  useEffect(() => {
    const role = secureStorage.getItem(SS_ROLE);
    setUserRole(role);
  }, []);

  const options = {
    scaleShowVerticalLines: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },

        ticks: {
          color: ["#38369C"],
        },
        pointStyle: "false",
        border: {
          display: true,
        },
      },

      y: {
        // min: 1000,
        // max: 10000,
        // ticks: {
        //   stepSize: 10,
        //   // callback: (value) => value + "L",
        //   callback: (value) => value + 1000,
        // },

        // border: {
        //   display: true,
        // },

        border: {
          dash: [5, 5],
          color: ["#CBCACA"],
        },

        ticks: {
          color: ["#38369C"],
        },
      },
    },
  };

  const getValues = (count, totalCount) => {
    return ((count / totalCount) * 100).toFixed(2);
  };

  //Doughnut chart data
  const successValue = getValues(
    dashboardValues?.allTransactions?.vanSuccess,
    dashboardValues?.allTransactions?.totalCount
  );

  const failureValue = getValues(
    dashboardValues?.allTransactions?.vanFailure,
    dashboardValues?.allTransactions?.totalCount
  );

  const data = {
    labels: [],
    datasets: [
      {
        label: "",
        data: [successValue, failureValue],
        backgroundColor: ["#3FA92F", "#E74242"],
        hoverOffset: 4,
        borderRadius: "8px",
      },
    ],
  };
  let hasVan;
  let hasVanUpi;

  let isClient = role === CLIENT;

  useEffect(() => {
    if (isClient) {
      hasVan = clientSecret.some(
        (obj) =>
          obj.serviceType?.toUpperCase() === "VAN" &&
          obj.serviceProviderName?.toUpperCase() === "EQUITAS"
      );

      hasVanUpi = clientSecret.some(
        (obj) =>
          obj.serviceType?.toUpperCase() === "VAN-UPI" &&
          obj.serviceProviderName?.toUpperCase() === "EQUITAS"
      );

      if (hasVan && hasVanUpi) {
        setCurrentSvcProvider({
          label: "Equitas Van",
          value: "van",
        });
        setOptsSvcArr(serviceProviders);
      } else if (hasVan) {
        setCurrentSvcProvider({
          label: "Equitas Van",
          value: "van",
        });
        setOptsSvcArr([
          {
            label: "Equitas Van",
            value: "van",
          },
        ]);
      } else if (hasVanUpi) {
        setCurrentSvcProvider({
          label: "Van Upi",
          value: "van-upi",
        });
        setOptsSvcArr([
          {
            label: "Van Upi",
            value: "van-upi",
          },
        ]);
      }
    }
  }, [isClient, clientSecret]);

  useEffect(() => {
    if (!isClient) {
      setCurrentSvcProvider({
        label: "Equitas Van",
        value: "van",
      });
      setOptsSvcArr(serviceProviders);
    }
  }, [!isClient]);

  const getVanDashboardValues = (daterange, userId, serviceProviderType) => {
    ApiRequestGet.getVanDashboardValues(
      daterange,
      userId,
      serviceProviderType,
      clientDetails?.program
    )
      .then((res) => {
        setDashboardValues(res);
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };

  const getVanTransactionCount = (updatedYear, userId, serviceProviderType) => {
    let dataset2 = [];
    console.log(userId, "USERID IN COUNT");

    const calenderData = [
      { label: "JAN", totalActualAmount: 0, totalTransactions: 0 },
      { label: "FEB", totalActualAmount: 0, totalTransactions: 0 },
      { label: "MAR", totalActualAmount: 0, totalTransactions: 0 },
      { label: "APR", totalActualAmount: 0, totalTransactions: 0 },
      { label: "MAY", totalActualAmount: 0, totalTransactions: 0 },
      { label: "JUN", totalActualAmount: 0, totalTransactions: 0 },
      { label: "JUL", totalActualAmount: 0, totalTransactions: 0 },
      { label: "AUG", totalActualAmount: 0, totalTransactions: 0 },
      { label: "SEP", totalActualAmount: 0, totalTransactions: 0 },
      { label: "OCT", totalActualAmount: 0, totalTransactions: 0 },
      { label: "NOV", totalActualAmount: 0, totalTransactions: 0 },
      { label: "DEC", totalActualAmount: 0, totalTransactions: 0 },
    ];

    function extractDataArrays() {
      const totalTransactionsArray = calenderData.map(
        (monthData) => monthData.totalTransactions || 0
      );

      return {
        totalTransactionsArray,
      };
    }
    ApiRequestGet.getVanTransactionCount(
      updatedYear,
      userId,
      serviceProviderType,
      clientDetails?.program
    )
      .then((apiResults) => {
        apiResults.forEach((result) => {
          const monthIndex = calenderData.findIndex(
            (month) =>
              month.label?.toLowerCase() === result.month?.toLowerCase()
          );
          if (monthIndex !== -1) {
            calenderData[monthIndex].totalActualAmount =
              result.totalActualAmount || 0;
            calenderData[monthIndex].totalTransactions =
              result.totalTransactions || 0;
          }
        });

        function getMonthLabels() {
          return calenderData.map((monthData) => monthData.label);
        }

        const chartData = extractDataArrays();
        setTransactionCount({
          labels: getMonthLabels(),
          datasets: [
            {
              label: "count",
              data: chartData?.totalTransactionsArray || [],
              borderColor: ["#38369C"],
              tension: 0.4,
              pointStyle: "false",
              pointRadius: 0,
              borderWidth: 1,
            },
          ],
        });
        // setTransactionVolume({
        //   labels: getMonthLabels(),
        //   datasets: [
        //     {
        //       label: "volume",
        //       data: chartData?.totalActualAmountArray || [],
        //       borderColor: ["#38369C"],
        //       tension: 0.4,
        //       pointStyle: "false",
        //       pointRadius: 0,
        //       borderWidth: 1,
        //     },
        //   ],
        // });
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };

  const getVanTransactionVolume = (
    updatedYear,
    userId,
    serviceProviderType
  ) => {
    let dataset2 = [];

    const calenderData = [
      { label: "JAN", totalActualAmount: 0, totalTransactions: 0 },
      { label: "FEB", totalActualAmount: 0, totalTransactions: 0 },
      { label: "MAR", totalActualAmount: 0, totalTransactions: 0 },
      { label: "APR", totalActualAmount: 0, totalTransactions: 0 },
      { label: "MAY", totalActualAmount: 0, totalTransactions: 0 },
      { label: "JUN", totalActualAmount: 0, totalTransactions: 0 },
      { label: "JUL", totalActualAmount: 0, totalTransactions: 0 },
      { label: "AUG", totalActualAmount: 0, totalTransactions: 0 },
      { label: "SEP", totalActualAmount: 0, totalTransactions: 0 },
      { label: "OCT", totalActualAmount: 0, totalTransactions: 0 },
      { label: "NOV", totalActualAmount: 0, totalTransactions: 0 },
      { label: "DEC", totalActualAmount: 0, totalTransactions: 0 },
    ];

    function extractDataArrays() {
      const totalActualAmountArray = calenderData.map(
        (monthData) => monthData.totalActualAmount || 0
      );

      return {
        totalActualAmountArray,
      };
    }

    ApiRequestGet.getVanDashboardVolume(
      updatedYear,
      userId,
      serviceProviderType,
      clientDetails?.program
    )
      .then((apiResults) => {
        apiResults.forEach((result) => {
          const monthIndex = calenderData.findIndex(
            (month) =>
              month.label?.toLowerCase() === result.month?.toLowerCase()
          );
          if (monthIndex !== -1) {
            calenderData[monthIndex].totalActualAmount =
              result.totalActualAmount || 0;
            calenderData[monthIndex].totalTransactions =
              result.totalTransactions || 0;
          }
        });

        function getMonthLabels() {
          return calenderData.map((monthData) => monthData.label);
        }

        const chartData = extractDataArrays();
        // setTransactionCount({
        //   labels: getMonthLabels(),
        //   datasets: [
        //     {
        //       label: "count",
        //       data: chartData?.totalTransactionsArray || [],
        //       borderColor: ["#38369C"],
        //       tension: 0.4,
        //       pointStyle: "false",
        //       pointRadius: 0,
        //       borderWidth: 1,
        //     },
        //   ],
        // });
        setTransactionVolume({
          labels: getMonthLabels(),
          datasets: [
            {
              label: "volume",
              data: chartData?.totalActualAmountArray || [],
              borderColor: ["#38369C"],
              tension: 0.4,
              pointStyle: "false",
              pointRadius: 0,
              borderWidth: 1,
            },
          ],
        });
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };

  const d = new Date();
  const dateMonthYear = moment(d).format("DD MMMM YYYY");
  const monthYear = moment(d).format("MMMM YY");
  const todayDate = moment(d).format("DD/MM/YYYY");
  var firstDay = new Date(d.getFullYear(), d.getMonth(), 1);
  var firstDayMonth = moment(firstDay).format("DD/MM/YYYY");
  const fromAndToDate =
    filters?.fromDate && filters?.toDate
      ? moment(filters?.fromDate).format("DD/MM/YYYY") +
        "-" +
        moment(filters?.toDate).format("DD/MM/YYYY")
      : `${firstDayMonth}-${todayDate}`;

  useEffect(() => {
    // to do
    getVanDashboardValues(
      fromAndToDate,
      "",
      currentSvcProvider?.value,
      clientDetails?.program
    );
  }, [fromAndToDate, clientDetails]);

  useEffect(() => {
    getVanTransactionCount("", "", currentSvcProvider?.value);
    getVanTransactionVolume("", "", currentSvcProvider?.value);
    getVanDashboardValues(fromAndToDate, "", currentSvcProvider?.value);
  }, [currentSvcProvider]);

  useEffect(() => {
    if (role === CLIENT) {
      dispatch(fetchClientSecretId());
    }
  }, []);

  return (
    <div style={styles.Container}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", gap: "50px" }}>
          {/* <div style={styles.settlediv}>
            <p style={styles.ptag3}>Settlement Amount</p>
            <p style={styles.amountsettle}>₹40,00,000</p>
          </div>
          <div style={styles.payindiv}>
            <p style={styles.ptag4}>  </p>
            <p style={styles.payinAmount}>₹40,00,000</p>
          </div> */}
        </div>
        <div
          style={{
            display: "flex",
          }}
        >
          <CustomSelect
            options={optsSvcArr}
            isSearchable={false}
            onChange={(data) => {
              setCurrentSvcProvider(data);
            }}
            value={currentSvcProvider}
            style={{
              height: 40,
              marginRight: 30,
              backgroundColor: "white",
              border: "1px solid #001777",
              "&:hover": {
                border: "1px solid #001777",
              },
              borderRadius: "4px",
            }}
          />
          <CustomButton
            title="Refresh"
            styles={{
              backgroundColor: colorWhite,
              width: "auto",
              padding: "0px 8px",
              marginTop: "-20px",
            }}
            textStyles={{
              color: colorBlack,
            }}
            icon={<TbRefresh size={20} color={primaryColor} />}
            onClick={() => {
              getVanDashboardValues(
                fromAndToDate,
                data?.clientId?.value,
                currentSvcProvider?.value
              );

              getVanTransactionCount(
                "",
                data?.clientId?.value,
                currentSvcProvider?.value
              );

              getVanTransactionVolume(
                "",
                data?.clientId?.value,
                currentSvcProvider?.value
              );
              dispatch(clearGlobalFilterReducer());
            }}
          />
          <div style={{ marginTop: "-20px" }}>
            <MainComponent
              currentServiceType={currentSvcProvider?.value}
              notificationRequired={false}
              dashboardFilterrequired={true}
              filterRequired={true}
              onClickFilter={() => {
                dispatch(
                  showHideFilterModalReducer({
                    showFilterModal: true,
                    filters: ["dateRange", "client", "business"],
                  })
                );
              }}
              onClickFilterCall={(data) => {
                const updatedDate = moment(data?.toDate).format("Do MMMM YYYY");
                const updatedYear = moment(data?.toDate).format("YYYY");

                setYear(updatedYear);
                setFilterDate(updatedDate);
                setOnClickFilter(true);

                getVanDashboardValues(
                  data?.fromDate && data?.toDate
                    ? moment(data?.fromDate).format("DD/MM/YYYY") +
                        "-" +
                        moment(data?.toDate).format("DD/MM/YYYY")
                    : "",
                  data?.clientId?.value,
                  currentSvcProvider?.value
                );
                setFilterDate(data?.toDate);

                getVanTransactionCount(
                  updatedYear,
                  data?.clientId?.value,
                  currentSvcProvider?.value
                );
                getVanTransactionVolume(
                  updatedYear,
                  data?.clientId?.value,
                  currentSvcProvider?.value
                );
              }}
            />
          </div>
        </div>
      </div>
      {/*LINE GRAPH 1 */}
      {aclData?.includes(VAN_TRANSACTION_RATE) && (
        <div style={styles.container1}>
          <div
            style={
              userRole === "CLIENT"
                ? { ...styles.first, minWidth: "31%" }
                : styles.first
            }
          >
            <div style={styles.innerdiv}>
              {onClickFilter ? (
                <>
                  <p style={{ margin: "2px 0 0 10px" }}>
                    {moment(filterDate).format("Do MMM YYYY")}
                  </p>
                </>
              ) : (
                <>
                  <p style={{ margin: "2px 0 0 10px" }}>{dateMonthYear}</p>
                </>
              )}
            </div>
            <p style={styles.heading}>Total transaction count</p>
            <p style={styles.amount}>
              {dashboardValues?.allTransactions?.totalCount
                ? dashboardValues?.allTransactions?.totalCount
                : 0}
            </p>
          </div>
          <div
            style={
              userRole === "CLIENT"
                ? { ...styles.second, minWidth: "32%" }
                : styles.second
            }
          >
            <div style={styles.innerdiv}>
              {onClickFilter ? (
                <>
                  <p style={{ margin: "2px 0 0 10px" }}>
                    {moment(filterDate).format("Do MMM YYYY")}
                  </p>
                </>
              ) : (
                <>
                  <p style={{ margin: "2px 0 0 10px" }}>{dateMonthYear}</p>
                </>
              )}
            </div>
            <p style={styles.heading}>Total Customer </p>
            <p style={styles.amount}>
              {dashboardValues?.customersCount
                ? dashboardValues?.customersCount
                : 0}
            </p>
          </div>
          {/* GRAPH 2 */}
          {userRole !== "CLIENT" && (
            <div style={styles.second}>
              <div style={styles.innerdiv}>
                {onClickFilter ? (
                  <>
                    <p style={{ margin: "2px 0 0 10px" }}>
                      {moment(filterDate).format("Do MMM YYYY")}
                    </p>
                  </>
                ) : (
                  <>
                    <p style={{ margin: "2px 0 0 10px" }}>{dateMonthYear}</p>
                  </>
                )}
              </div>
              <p style={styles.heading}>Total Client</p>
              <p style={styles.amount}>
                {dashboardValues?.clientCount
                  ? dashboardValues?.clientCount
                  : 0}
              </p>
            </div>
          )}
          <div
            style={
              userRole === "CLIENT"
                ? { ...styles.first, minWidth: "31%" }
                : styles.first
            }
          >
            <div style={styles.innerdiv}>
              {onClickFilter ? (
                <>
                  <p style={{ margin: "2px 0 0 10px" }}>
                    {moment(filterDate).format("Do MMM YYYY")}
                  </p>
                </>
              ) : (
                <>
                  <p style={{ margin: "2px 0 0 10px" }}>{dateMonthYear}</p>
                </>
              )}
            </div>
            <p style={styles.rate}>Transaction Rate</p>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <div>
                <p style={styles.value}>Success</p>
                <p style={styles.value}>Failed</p>
              </div>
              <div>
                <p style={styles.value}>
                  {dashboardValues?.allTransactions?.vanSuccess
                    ? dashboardValues?.allTransactions?.vanSuccess
                    : 0}
                </p>
                <p style={styles.value}>
                  {dashboardValues?.allTransactions?.vanFailure
                    ? dashboardValues?.allTransactions?.vanFailure
                    : 0}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      <div style={styles.container2}>
        <div style={{ width: "65%" }}>
          {aclData?.includes(VAN_TRANSACTION_VOLUME) && (
            <div style={styles.volumediv}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  paddingLeft: "25px",
                }}
              >
                <p style={styles.ptag}>Transaction volume</p>
                <div style={styles.year}>
                  <p style={styles.ptag1}>{Year}</p>
                </div>
              </div>
              {transactionVolume && (
                <Line
                  data={{
                    ...transactionVolume,
                    datasets: transactionVolume.datasets.map((dataset) => ({
                      ...dataset,
                      data: dataset.data.map((value) => value / 100),
                    })),
                  }}
                  options={options}
                  style={{ padding: "0 20px 30px 20px" }}
                />
              )}
            </div>
          )}
          {aclData?.includes(VAN_TRANSACTION_COUNT) && (
            <div style={styles.volumediv}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  paddingLeft: "25px",
                }}
              >
                <p style={styles.ptag}>Transactions count</p>
                <div style={styles.year}>
                  <p style={styles.ptag1}>{Year}</p>
                </div>
              </div>
              {transactionCount && (
                <Line
                  data={transactionCount}
                  options={options}
                  style={{ padding: "0 20px 30px 20px" }}
                />
              )}
            </div>
          )}
        </div>
        {aclData?.includes(VAN_TRANSACTION_RATE) && (
          <div style={{ width: "35%" }}>
            <div style={styles.rightdiv}>
              <div style={styles.innerdiv1}>
                {onClickFilter ? (
                  <>
                    <p style={{ margin: "2px 0 0 10px" }}>
                      {moment(filterDate).format("MMM YYYY")}
                    </p>
                  </>
                ) : (
                  <>
                    <p style={{ margin: "2px 0 0 10px" }}>{monthYear}</p>
                  </>
                )}
              </div>
              <p style={styles.rate}>
                Transaction Volume: ₹
                {dashboardValues?.actualAmountRange?.totalActualAmount / 100}
              </p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                }}
              >
                <div>
                  <p style={styles.value}>Min amount</p>
                  <p style={styles.value}>
                    ₹
                    {dashboardValues?.actualAmountRange?.minActualAmount > 0
                      ? dashboardValues?.actualAmountRange?.minActualAmount /
                        100
                      : 0}
                  </p>
                </div>
                <div>
                  <p style={styles.value}>Max amount</p>
                  <p style={styles.value}>
                    ₹
                    {dashboardValues?.actualAmountRange?.maxActualAmount > 0
                      ? dashboardValues?.actualAmountRange?.maxActualAmount /
                        100
                      : 0}
                  </p>
                </div>
              </div>
            </div>
            <div style={styles.rateContainer}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p style={styles.ptag}>Transaction Rate</p>
                <div style={styles.rateYear}>
                  {onClickFilter ? (
                    <>
                      <p style={{ margin: "2px 0 0 10px" }}>
                        {moment(filterDate).format("Do MMM YYYY")}
                      </p>
                    </>
                  ) : (
                    <>
                      <p style={{ margin: "2px 0 0 10px" }}>{dateMonthYear}</p>
                    </>
                  )}
                </div>
              </div>
              <div style={styles.donutGraph}>
                <Doughnut data={data} />
              </div>
              <div
                style={{
                  display: "flex",
                  margin: "50px 30px 0 30px",
                  justifyContent: "space-around",

                  padding: "0 20px 0 20px",
                }}
              >
                <div style={styles.circle1}></div>
                <p style={styles.ptag2}>Success rate</p>
                <p style={styles.percentage}>
                  {Math.floor(
                    (dashboardValues?.allTransactions?.vanSuccess /
                      (dashboardValues?.allTransactions?.vanSuccess +
                        dashboardValues?.allTransactions?.vanFailure)) *
                      100
                  )}
                  %
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  margin: "10px 30px 0 30px",
                  justifyContent: "space-around",
                  padding: "0 20px 0 20px",
                }}
              >
                <div style={styles.circle2}></div>
                <p style={styles.ptag2}>Failure rate</p>
                <p style={styles.percentage}>
                  {Math.floor(
                    (dashboardValues?.allTransactions?.vanFailure /
                      (dashboardValues?.allTransactions?.vanSuccess +
                        dashboardValues?.allTransactions?.vanFailure)) *
                      100
                  )}
                  %
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const styles = {
  Container: {
    marginLeft: "30px",
    marginTop: "2%",
    width: "100%",
    marginRight: "30px",
  },
  container1: {
    display: "flex",

    width: "100%",
  },
  first: {
    minWidth: "25%",
    height: "178px",
    background: "#FFFFFF",
    border: "1px solid rgba(155, 174, 210, 0.55)",
    borderRadius: "8px",
    marginRight: "35px",
  },
  second: {
    boxSizing: "border-box",
    minWidth: "21%",
    height: "178px",
    background: "#FFFFFF",
    border: "1px solid rgba(155, 174, 210, 0.55)",
    borderRadius: "8px",
    marginRight: "30px",
  },
  ptag3: {
    fontWeight: "600",
    fontSize: "14px",
    color: "#38369C",
    alignItems: "center",
    width: "135px",
    marginRight: "10px",
  },
  amountsettle: {
    fontWeight: "600",
    fontSize: "14px",
    color: "#38369C",
    alignItems: "center",
  },
  payinAmount: {
    fontWeight: "600",
    fontSize: "14px",
    color: "#3FA92F",
    alignItems: "center",
    width: "100px",
  },
  ptag4: {
    fontWeight: "600",
    fontSize: "14px",
    color: "#3FA92F",
    width: "100px",
    marginRight: "10px",
    alignItems: "center",
  },
  settlediv: {
    background: "rgba(56, 54, 156, 0.1)",
    borderRadius: "5px",
    width: "280px",
    height: "45px",
    marginBottom: "20px",
    alignItems: "center",
    paddingLeft: "20px",
    display: "flex",
  },
  payindiv: {
    background: "rgba(63, 169, 47, 0.1)",
    borderRadius: "5px",
    width: "250px",
    height: "45px",
    marginBottom: "20px",
    alignItems: "center",
    paddingLeft: "20px",
    display: "flex",
  },

  container2: {
    display: "flex",
    width: "100%",
  },
  volumediv: {
    width: "97.3%",
    //height: "440px",
    background: "#FFFFFF",
    borderRadius: "8px",
    marginTop: "20px",
    //marginRight: "20px",
    paddingLeft: "20px",
  },
  rightdiv: {
    //minWidth: "400px",
    height: "230px",
    marginTop: "20px",
    background: "#FFFFFF",
    border: "1px solid rgba(155, 174, 210, 0.55)",
    borderRadius: "8px",
  },
  rateContainer: {
    //minWidth: "400px",
    height: "500px",
    marginTop: "20px",
    background: "#FFFFFF",
    border: "1px solid rgba(155, 174, 210, 0.55)",
    borderRadius: "8px",
    padding: "0 20px 0 20px",
  },
  innerdiv: {
    minWidth: "150px",
    height: "33px",
    background: "#FDFDFD",
    border: "1px solid rgba(155, 174, 210, 0.2)",
    borderRadius: "8px",
    float: "right",
    margin: "10px",
    //border: "1px solid #38369C",
  },
  innerdiv1: {
    width: "100px",
    height: "33px",
    background: "#FDFDFD",
    border: "1px solid rgba(155, 174, 210, 0.2)",
    borderRadius: "8px",
    float: "right",
    margin: "10px",
  },
  heading: {
    fontWeight: "500",
    fontSize: "18px",
    lineHeight: "22px",
    color: "#1E2234",
    marginTop: "80px",
    marginLeft: "20px",
  },
  amount: {
    fontWeight: "700",
    fontSize: "24px",
    lineHeight: "29px",
    display: "flex",
    alignItems: "center",
    color: "#1E2234",
    marginLeft: "20px",
    marginTop: "20px",
  },
  rate: {
    fontWeight: "500",
    fontSize: "18px",
    lineHeight: "22px",
    color: "#1E2234",
    margin: "60px 0 0 20px",
  },
  value: {
    fontWeight: "500",
    fontSize: "18px",
    lineHeight: "22px",
    color: "#1E2234",
    margin: "10px 10px 0 20px ",
  },
  ptag: {
    fontWeight: "600",
    fontSize: "16px",
    color: "#1E2234",
    paddingTop: "10px",
  },
  ptag1: {
    fontWeight: "600",
    fontSize: "16px",
    color: "#1E2234",
    padding: "3px 0 0 7px",
  },
  ptag2: {
    fontWeight: "400",
    fontSize: "18px",
    color: "#565656",
    width: "150px",
    paddingLeft: "20px",
    //marginLeft: "-40px",
  },

  year: {
    width: "57px",
    height: "33px",
    margin: "10px 10px 0 0",
    background: "#FDFDFD",
    border: "1px solid #38369C",
    borderRadius: "8px",
  },
  rateYear: {
    width: "136px",
    height: "33px",
    background: "#FDFDFD",
    //border: "1px solid #38369C",
    borderRadius: "8px",
    marginTop: "10px",
    border: "1px solid rgba(155, 174, 210, 0.2)",
  },
  donutGraph: {
    maxWidth: "250px",
    maxHeight: "250px",
    background: "#FFFFFF",
    //boxShadow: "0px 0px 4px rgba(0, 23, 119, 0.12)",

    alignItems: "center",
    margin: "auto",
    marginTop: "50px",

    marginLeft: "15%",
  },
  circle1: {
    width: "18px",
    height: "18px",
    background: "#3FA92F",
    borderRadius: "9px",
    marginTop: "4px",
  },
  circle2: {
    width: "18px",
    height: "18px",
    background: "#E74242",
    borderRadius: "9px",
    marginTop: "4px",
  },
  percentage: {
    fontWeight: "500",
    fontSize: "18px",
    color: "#1E2234",
    marginLeft: "30px",
  },
};

export default VanDashbaordIndex;
